import React, { useState, useEffect } from "react";
import './SalaryStructure.css';
import Select from 'react-select';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { useNavigate } from "react-router-dom"; // For navigation
import { getAllEmployees, salaryPost } from "../../../services/salaryStructureService";
import { selectStyles } from "../../../assets/Styles/selectStyle";
const SalaryStructure = () => {
  const navigate = useNavigate();
  const [ctc, setCtc] = useState('');
  const [basic, setBasic] = useState('');
  const [hra, setHra] = useState('');
  const [conveyance, setConveyance] = useState(1600);
  const [medicalAllowance, setMediacalAllowance] = useState(500);
  const [otherAllowance, setSpecialAllowance] = useState('');
  const [grossSalary, setGrossSalary] = useState('');
  const [employeerEpf, setEmployeerEpf] = useState('');
  const [employeerEsi, setEmployeerEsi] = useState('');
  const [ctcAs, setCtcAs] = useState('');
  const [difference, setDifference] = useState('');
  const [employeeEpf, setEmployeeEpf] = useState('');
  const [employeeEsi, setEmployeeEsi] = useState('');
  const [pt, setPt] = useState('');
  const [incomeTax, setIncomeTax] = useState('');
  const [totalDedutions, setTotalDedutions] = useState('');
  const [netSalary, setSalary] = useState('');
  const [error, setError] = useState('');
  const [designation, setDesignation] = useState("");
  const [employeeUniqueId, setemployeeUniqueId] = useState("");

  // Calculate values based on CTC
  useEffect(() => {
    if (!ctc || isNaN(ctc) || parseFloat(ctc) <= 0) {
      // If CTC is empty, invalid, or zero, don't perform any calculation
      return;
    }
    const numericCtc = parseFloat(ctc);
    const calculatedBasic = numericCtc * 0.4;
    const calculatedHra = calculatedBasic * 0.4;
    const calculatedGrossSalary = calculatedBasic + calculatedHra + conveyance + medicalAllowance + parseFloat(otherAllowance || 0);

    const epf = Math.min(15000, calculatedBasic) * 0.13;
    // Apply ESI only if Gross Salary <= 21000
    const esi = calculatedGrossSalary <= 21000 ? calculatedGrossSalary * 0.0325 : 0;
    const calculatedCtcAs = calculatedGrossSalary + epf + esi;
    //const diff = numericCtc - calculatedCtcAs;
    const diff = Math.round(numericCtc - calculatedCtcAs);
    const calculatedEmployeeEpf = Math.min(15000, calculatedBasic) * 0.12;
    const calculatedEmployeeEsi = calculatedGrossSalary <= 21000 ? calculatedGrossSalary * 0.0075 : 0;

    let ptValue = 0;
    if (calculatedGrossSalary <= 15000) ptValue = 0;
    else if (calculatedGrossSalary <= 20000) ptValue = 150;
    else ptValue = 200;

    const calculatedTotalDeductions = calculatedEmployeeEpf + calculatedEmployeeEsi + ptValue + parseFloat(incomeTax || 0);
    const calculatedNetSalary = calculatedGrossSalary - calculatedTotalDeductions;

    setBasic(calculatedBasic);
    setHra(calculatedHra);
    setGrossSalary(calculatedGrossSalary);
    setEmployeerEpf(epf);
    setEmployeerEsi(esi);
    setCtcAs(calculatedCtcAs);
    setDifference(diff);
    setEmployeeEpf(calculatedEmployeeEpf);
    setEmployeeEsi(calculatedEmployeeEsi);
    setPt(ptValue);
    setTotalDedutions(calculatedTotalDeductions);
    setSalary(calculatedNetSalary);
  }, [ctc, otherAllowance, incomeTax]);

  // Clear form
  const handleClear = () => {
    setCtc('');
    setBasic('');
    setHra('');
    setConveyance(1600);
    setMediacalAllowance(500);
    setSpecialAllowance('');
    setGrossSalary('');
    setEmployeerEpf('');
    setEmployeerEsi('');
    setCtcAs('');
    setDifference('');
    setEmployeeEpf('');
    setEmployeeEsi('');
    setPt('');
    setIncomeTax('');
    setTotalDedutions('');
    setSalary('');
    setError('');
    // setConveyance('');
    // setMediacalAllowance('');
  };

  // Cancel button → navigate
  const handleCancel = () => {
    navigate("/dashboard"); // change path as per your app
  };
  const [employees, setEmployees] = useState([]);
  const [employeeName, setEmployee] = useState(null);
  const [isFocused, setIsFocused] = useState({ employeeName: false });
  // Fetch employees
  const fetchEmployees = async () => {
    try {
      //const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/personal-info/status?status=APPROVED`);
      // const data = response.data;
      const data = await getAllEmployees();
      if (Array.isArray(data)) {
        setEmployees(
          data.map((item) => {
            const info = item.personalInformation;
            return {
              value: info.employeeUniqueId, // ✅ ensures uniqueness
              label: `${info.fullName || ""}- ${info.employeeId || ""}`.trim(),
              designation: info.designation || "",
              raw: info
            };
          })
        );

      } else {
        console.error("Invalid response format: employees should be an array");
      }
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };
  useEffect(() => {

    fetchEmployees();
  }, []);




  const handleInputChange = (selectedOption, field) => {
    if (field === "employeeName") {
      setEmployee(selectedOption ? selectedOption.value : null);
      setDesignation(selectedOption ? selectedOption.designation : "");
      setemployeeUniqueId(selectedOption ? selectedOption.raw.employeeId : "");
    }
  };
  // Save button → API call
  const handleSave = async () => {
    const payload = {
      ctc,
      basicSalary: basic,   // match API field names
      hra,
      conveyance,
      medicalAllowance,
      otherAllowance,
      grossSalary,
      // employerEpf: employeerEpf,          // spelling fix
      //employerEsi: employeerEsi,
      // ctcAsPerBreakup: ctcAs,
      //difference,
      //epf: employeeEpf,
      //esi: employeeEsi,
      // pt,
      //incomeTax,
      //totalDeductions: totalDedutions,      // spelling fix
      //netSalary,
    };

    try {
      //const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/salary-structure/${employeeUniqueId}`,payload);
      const response = await salaryPost(employeeUniqueId, payload);
      console.log("Saved successfully:", response.data);
      alert("Salary saved successfully!");
      setEmployee(null);
      setDesignation(" ");
      handleClear();
      fetchEmployees();

    } catch (err) {
      console.error("Error saving salary:", err);
      alert("Error while saving salary");
    }
  };


  return (
    <div className="salarystructure-maincontainer">
      <div className="salarystructure-box">
        <h2 className="salarystructure-heading">Salary Structure</h2>
        <div className="salary-structure-heading">
          {/*Employee Name */}
          <div className="salaryStructure-maincontainer-1">
            <div className="salaryStructure-container-part">
              <div
                className={`salaryStructure-floating-label-container-2 ${isFocused.employeeName || employeeName ? "float-label" : ""
                  }`}
              >
                <Select
                  name="employeeName"
                  options={employees}
                  value={employees.find((opt) => opt.value === employeeName) || null}
                  onChange={(selectedOption) =>
                    handleInputChange(selectedOption, "employeeName")
                  }
                  onFocus={() => setIsFocused((prev) => ({ ...prev, employeeName: true }))}
                  onBlur={() => setIsFocused((prev) => ({ ...prev, employeeName: false }))}
                  placeholder=" "
                  isClearable
                  menuPortalTarget={document.body}
                  // styles={{
                  //   menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  //   menu: (base) => ({ ...base, marginTop: "5px", zIndex: 9999 }),
                  //   control: (provided) => ({ ...provided, padding: "1px" }),
                  //   valueContainer: (provided) => ({ ...provided, padding: "3px 6px" }),
                  // }}
                  styles={selectStyles}
                />
                <label><span className="required">*</span>Employee Name</label>
              </div>

            </div>
            <div className="salaryStructure-container-part">
              <div className="salaryStructure-floating-label-container-2">
                <input
                  type="text"
                  name="designation"
                  value={designation}
                  readOnly
                  placeholder=" "
                  required
                />

                <label>Designation</label>
              </div>
            </div>
          </div>

          {/* CTC */}
          <div className="salaryStructure-maincontainer-1">
            <div className="salaryStructure-container-part">
              <div className="salaryStructure-floating-label-container-2">
                <input
                  type="text"
                  name="ctc"
                  value={ctc}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, ""); // remove non-digits
                    setCtc(value);
                  }}
                  placeholder=" "
                  maxLength={7}
                  required
                />
                <label><span className="required">*</span>CTC</label>
              </div>

            </div>
            <div className="salaryStructure-container-part">
              {/* <div className="salaryStructure-floating-label-container-2">
              <input
                type="text"
                name="ctc"
                value={ctc}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, ""); // remove non-digits
                  setCtc(value);
                }}
                placeholder=" "
                maxLength={7}
                required
              />
              <label><span className="required">*</span>CTC</label>
            </div> */}

            </div>
          </div>
          <div className="ear-ded">

            <div className="ear-inside">
              <div className="contribution-header">
                Employee Earnings
              </div>
              {/* Basic Salary */}
              <div className="salaryStructure-maincontainer">
                <div className="salaryStructure-container-part">
                  <div className="salaryStructure-floating-label-container-2">
                    <input
                      type="text"
                      name="basic"
                      value={typeof basic === 'number' ? basic.toFixed(0) : ''}
                      readOnly
                      placeholder=" "
                      required
                    />
                    <label>Basic Salary</label>
                  </div>
                </div>

              </div>

              {/* HRA */}
              <div className="salaryStructure-maincontainer">
                <div className="salaryStructure-container-part">
                  <div className="salaryStructure-floating-label-container-2">
                    <input
                      type="text"
                      name="hra"
                      value={typeof hra === 'number' ? hra.toFixed(0) : ''}
                      readOnly
                      placeholder=" "
                      required
                    />
                    <label>HRA</label>
                  </div>
                </div>

              </div>

              {/* Conveyance */}
              <div className="salaryStructure-maincontainer">
                <div className="salaryStructure-container-part">
                  <div className="salaryStructure-floating-label-container-2">
                    <input
                      type="text"
                      name="conveyance"
                      value={conveyance}
                      readOnly
                      placeholder=" "
                      required
                    />
                    <label>Conveyance</label>
                  </div>
                </div>

              </div>

              {/* Medical Allowance */}
              <div className="salaryStructure-maincontainer">
                <div className="salaryStructure-container-part">
                  <div className="salaryStructure-floating-label-container-2">
                    <input
                      type="text"
                      name="medicalAllowance"
                      value={medicalAllowance}
                      readOnly
                      placeholder=" "
                      required
                    />
                    <label>Medical Allowance</label>
                  </div>

                </div>

              </div>

              {/* Special Allowance */}
              <div className="salaryStructure-maincontainer">
                <div className="salaryStructure-container-part">
                  <div className="salaryStructure-floating-label-container-2">
                    <input
                      type="text"
                      name="otherAllowance"
                      value={otherAllowance}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, ""); // remove non-digits
                        setSpecialAllowance(value);
                      }}
                      placeholder=" "
                      maxLength={7}
                      required
                    />
                    <label>Other Allowance</label>
                  </div>
                </div>




              </div>

              {/* Gross Salary */}
              <div className="salaryStructure-maincontainer">
                <div className="salaryStructure-container-part">
                  <div className="salaryStructure-floating-label-container-2">
                    <input className="netSalary-input"
                      type="text"
                      name="grossSalary"
                      value={typeof grossSalary === 'number' ? grossSalary.toFixed(0) : ''}
                      readOnly
                      placeholder=" "
                      required
                    />
                    <label >Gross Salary</label>
                  </div>
                </div>

              </div>

              {/* Employer Contribution */}
              <div className="contribution-header">
                Employer Contribution
              </div>

              {/* EPF */}
              <div className="salaryStructure-maincontainer">
                <div className="salaryStructure-container-part">
                  <div className="salaryStructure-floating-label-container-2">
                    <input
                      type="text"
                      name="employeerEpf"
                      value={typeof employeerEpf === 'number' ? employeerEpf.toFixed(0) : ''}
                      readOnly
                      placeholder=" "
                      required
                    />
                    <label>EPF</label>
                  </div>
                </div>

              </div>

              {/* ESI */}
              <div className="salaryStructure-maincontainer">
                <div className="salaryStructure-container-part">
                  <div className="salaryStructure-floating-label-container-2">
                    <input
                      type="text"
                      name="employeerEsi"

                      value={typeof employeerEsi === 'number' ? employeerEsi.toFixed(0) : ''}
                      readOnly
                      placeholder=" "
                      required
                    />
                    <label>ESI</label>
                  </div>
                </div>

              </div>

              {/* CTC as per Breakup */}
              <div className="salaryStructure-maincontainer">
                <div className="salaryStructure-container-part">
                  <div className="salaryStructure-floating-label-container-2">
                    <input
                      type="text"
                      name="ctcAs"
                      value={typeof ctcAs === 'number' ? ctcAs.toFixed(0) : ''}
                      readOnly
                      placeholder=" "
                      required
                    />
                    <label>CTC As per Breakup</label>
                  </div>
                </div>

              </div>

              {/* Difference */}
              <div className="salaryStructure-maincontainer">
                <div className="salaryStructure-container-part">
                  <div className="salaryStructure-floating-label-container-2">
                    <input
                      type="text"
                      name="difference"
                      value={typeof difference === 'number' ? difference.toFixed(0) : ''}
                      readOnly
                      placeholder=" "
                      required
                    />
                    <label>Difference</label>
                    {typeof difference === 'number' &&
                      difference !== 0 &&
                      difference !== 1 && (
                        <span className="error-message">Difference should be 0 or 1</span>
                      )}
                  </div>
                </div>
              </div>
            </div>
            <div className="ear-inside">

              {/* Employee Deductions */}
              <div className="contribution-header">
                Employee Deductions
              </div>

              {/* EPF */}
              <div className="salaryStructure-maincontainer">
                <div className="salaryStructure-container-part">
                  <div className="salaryStructure-floating-label-container-2">
                    <input
                      type="text"
                      name="employeeEpf"
                      value={typeof employeeEpf === 'number' ? employeeEpf.toFixed(0) : ''}
                      readOnly
                      placeholder=" "
                      required
                    />
                    <label>EPF</label>
                  </div>
                </div>

              </div>

              {/* ESI */}
              <div className="salaryStructure-maincontainer">
                <div className="salaryStructure-container-part">
                  <div className="salaryStructure-floating-label-container-2">
                    <input
                      type="text"
                      name="employeeEsi"

                      value={typeof employeeEsi === 'number' ? employeeEsi.toFixed(0) : ''}
                      readOnly
                      placeholder=" "
                      required
                    />
                    <label>ESI</label>
                  </div>
                </div>

              </div>

              {/* PT */}
              <div className="salaryStructure-maincontainer">
                <div className="salaryStructure-container-part">
                  <div className="salaryStructure-floating-label-container-2">
                    <input
                      type="text"
                      name="pt"
                      value={pt}
                      readOnly
                      placeholder=" "
                      required
                    />
                    <label>PT</label>
                  </div>
                </div>

              </div>

              {/* Income Tax */}
              <div className="salaryStructure-maincontainer">
                <div className="salaryStructure-container-part">
                  <div className="salaryStructure-floating-label-container-2">
                    <input
                      type="text"
                      name="incomeTax"
                      value={incomeTax}
                      onChange={(e) => setIncomeTax(e.target.value)}
                      placeholder=" "
                      required
                    />
                    <label>Income Tax</label>
                  </div>
                </div>

              </div>

              {/* Total Deductions */}
              <div className="salaryStructure-maincontainer">
                <div className="salaryStructure-container-part">
                  <div className="salaryStructure-floating-label-container-2">
                    <input className="netSalary-input"
                      type="text"
                      name="totalDeductions"

                      value={typeof totalDedutions === 'number' ? totalDedutions.toFixed(0) : ''}
                      readOnly
                      placeholder=" "
                      required
                    />
                    <label>Total Deductions</label>
                  </div>
                </div>

              </div>

              {/* Net Salary */}
              <div className="salaryStructure-maincontainer">
                <div className="salaryStructure-container-part">
                  <div className="salaryStructure-floating-label-container-2">
                    <input className="netSalary-input"
                      type="text"
                      name="netSalary"
                      value={typeof netSalary === 'number' ? netSalary.toFixed(0) : ''}
                      readOnly
                      placeholder=" "
                      required
                    />
                    <label>Net Salary</label>
                  </div>
                </div>

              </div>
              <div className="salaryStructure-btn-div">
                <button type="button" className="salaryStructure-cancel" onClick={handleCancel}>
                  Cancel
                </button>
                <button type="button" className="salaryStructure-clear" onClick={handleClear}>
                  Clear
                </button>
                <button
                  type="button"
                  className="salaryStructure-btn"
                  onClick={handleSave}
                  disabled={!(difference === 0 || difference === 1)}
                >
                  Save
                </button>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalaryStructure;
